export default __webpack_public_path__ + "static/media/arrow_dropdown-white.91fb452f.svg";